module.exports = __webpack_public_path__ + "static/media/LVS_03.aa4969be.jpeg";